// 260911nrai: Admin → Aktive Benutzer — ajax refresh + session watchdog modal

const CURRENT_USERS_MODAL_ID = 'current_users_watchdogs_modal';
const CURRENT_USERS_MODAL_BODY_ID = 'current_users_watchdogs_modal_body';

function currentUsersListEl() {
  return document.getElementById('current_users_list');
}

function currentUsersModal() {
  return window.jQuery ? window.jQuery(`#${CURRENT_USERS_MODAL_ID}`) : null;
}

function ensureCurrentUsersReveal($modal) {
  if (!$modal || !$modal.length) return;
  $modal.removeData('css-top').removeData('offset');
  if (!$modal.data('reveal')) {
    try {
      $modal.foundation('reveal');
    } catch (e) {
      // already inited
    }
  }
}

function openCurrentUsersWatchdogsModal(url) {
  const $modal = currentUsersModal();
  if (!$modal || !$modal.length) {
    window.location.href = url;
    return;
  }

  const body = document.getElementById(CURRENT_USERS_MODAL_BODY_ID);
  if (body) {
    body.innerHTML = '<p class="smallinfo">Statistik wird geladen…</p>';
  }

  ensureCurrentUsersReveal($modal);
  $modal.foundation('reveal', 'open');

  fetch(url, {
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then((response) => response.text().then((html) => ({ ok: response.ok, html })))
    .then(({ ok, html }) => {
      const target = document.getElementById(CURRENT_USERS_MODAL_BODY_ID);
      if (!target) return;
      if (ok && html) {
        target.innerHTML = html;
      } else {
        target.innerHTML = html || '<p class="warningarea">Statistik konnte nicht geladen werden.</p>';
      }
    })
    .catch(() => {
      const target = document.getElementById(CURRENT_USERS_MODAL_BODY_ID);
      if (target) {
        target.innerHTML = '<p class="warningarea">Statistik konnte nicht geladen werden.</p>';
      }
    });
}

function bindCurrentUsersSessionClicks() {
  const $ = window.jQuery;
  if (!$) return;

  $(document)
    .off('click.currentUsersSessionStat', '.current-users-session-stat')
    .on('click.currentUsersSessionStat', '.current-users-session-stat', function (event) {
      event.preventDefault();
      openCurrentUsersWatchdogsModal(this.href);
    });
}

function initCurrentUsersPage() {
  const container = currentUsersListEl();
  if (!container) return;

  ensureCurrentUsersReveal(currentUsersModal());
  bindCurrentUsersSessionClicks();
}

window.initCurrentUsersPage = initCurrentUsersPage;

export { initCurrentUsersPage };
